import { Link } from "react-router-dom";
import { Headphones, ShoppingCart, Home, Megaphone, Briefcase, ArrowRight } from "lucide-react";

import { useTranslation } from 'react-i18next';
const AGENTS = [
  {
    slug: "customer-support",
    icon: Headphones,
    titleKey: "marketplace_section.agent_customer_support",
    descKey: "marketplace_section.agent_customer_support_desc",
    price: "$99/mo",
    channels: "WhatsApp · Telegram · Email · Discord",
    href: "/marketplace/customer-support",
    color: "#f59e0b",
    type: "agent",
    badge: "AGENTE PRONTO PARA USAR",
  },
  {
    slug: "ecommerce",
    icon: ShoppingCart,
    titleKey: "marketplace_section.agent_ecommerce",
    descKey: "marketplace_section.agent_ecommerce_desc",
    price: "$149/mo",
    channels: "WhatsApp · Instagram · Email",
    href: "/marketplace/ecommerce",
    color: "#f59e0b",
    type: "agent",
    badge: "AGENTE PRONTO PARA USAR",
  },
  {
    slug: "real-estate",
    icon: Home,
    titleKey: "marketplace_section.agent_real_estate",
    descKey: "marketplace_section.agent_real_estate_desc",
    price: "$197/mo",
    channels: "WhatsApp · Instagram · Facebook",
    href: "/marketplace/real-estate",
    color: "#f59e0b",
    type: "agent",
    badge: "AGENTE PRONTO PARA USAR",
  },
  {
    slug: "marketing-agencies",
    icon: Megaphone,
    titleKey: "marketplace_section.agent_marketing_agencies",
    descKey: "marketplace_section.agent_marketing_agencies_desc",
    price: "$249/mo",
    channels: "Instagram · X · Facebook · LinkedIn",
    href: "/marketplace/marketing-agencies",
    color: "#f59e0b",
    type: "agent",
    badge: "AGENTE PRONTO PARA USAR",
  },
  {
    slug: "consultancy",
    icon: Briefcase,
    titleKey: "marketplace_section.agent_consultancy",
    descKey: "marketplace_section.agent_consultancy_desc",
    price: "$149/mo",
    channels: "Email · Telegram · WhatsApp",
    href: "/marketplace/consultancy",
    color: "#f59e0b",
    type: "agent",
    badge: "AGENTE PRONTO PARA USAR",
  },
];

// SKILLS separadas - produto secundário
const SKILLS_CATALOG = [
  {
    slug: "stripe-payments",
    titleKey: "marketplace_section.skill_stripe",
    descKey: "marketplace_section.skill_stripe_desc",
    price: "+$29/mo",
    href: "/marketplace/skills/stripe",
  },
  {
    slug: "shopify-integration",
    titleKey: "marketplace_section.skill_shopify",
    descKey: "marketplace_section.skill_shopify_desc",
    price: "+$39/mo",
    href: "/marketplace/skills/shopify",
  },
  {
    slug: "notion-sync",
    titleKey: "marketplace_section.skill_notion",
    descKey: "marketplace_section.skill_notion_desc",
    price: "+$19/mo",
    href: "/marketplace/skills/notion",
  },
];

export default function MarketplaceSection() {
  const { t } = useTranslation();
  return (
    <section className="bg-black border-t border-zinc-900" aria-labelledby="marketplace-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 sm:py-24">
        {/* Section header */}
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4" aria-hidden="true">
              // AGENT MARKETPLACE
            </div>
            <h2 id="marketplace-heading" className="font-display text-2xl sm:text-4xl md:text-5xl uppercase leading-tight">
              <span className="text-amber-500">{t('marketplace_section.choose_your_digital_worker')}</span><br/>
              {t('marketplace_section.ready_to_deploy_ai_agents_for_your_industry')}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 self-end">
            <p className="text-zinc-400 text-lg leading-relaxed">{t('marketplace_section.skip_the_configuration_choose_a_pre_trained_agent')}</p>
          </div>
        </div>

        {/* Agent cards grid - PRODUTO PRINCIPAL */}
        <div className="mb-16">
          <h3 className="font-display text-xl uppercase text-amber-500 mb-6">AGENTES PRONTOS PARA USAR</h3>
          <p className="text-zinc-400 mb-8 max-w-2xl">Escolha um agente especializado para sua vertical. Cada agente vem com skills otimizados para o seu setor e pode ser ativado em 5 minutos.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {AGENTS.slice(0, 3).map((agent) => {
              const Icon = agent.icon;
              return (
                <Link
                  key={agent.slug}
                  to={agent.href}
                  className="group border border-zinc-800 hover:border-amber-500/30 bg-[#09090B] p-8 transition-all duration-300 hover:bg-zinc-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
                >
                  <div className="flex items-start justify-between mb-4">
                    <Icon className="w-8 h-8 text-amber-500" aria-hidden="true" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500">{agent.badge}</span>
                  </div>
                  <h3 className="font-display text-xl uppercase mb-2 group-hover:text-amber-500 transition-colors">
                    {t(agent.titleKey)}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed mb-4">{t(agent.descKey)}</p>
                  <div className="font-display text-2xl text-amber-500 mb-2">{agent.price}</div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-400 mb-6">
                    {agent.channels}
                  </p>
                  <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 group-hover:text-amber-500 transition-colors">
                    {t('marketplace_section.view_agent')} <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>

        {/* Agent cards - restantes */}
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {AGENTS.slice(3).map((agent) => {
              const Icon = agent.icon;
              return (
                <Link
                  key={agent.slug}
                  to={agent.href}
                  className="group border border-zinc-800 hover:border-amber-500/30 bg-[#09090B] p-8 transition-all duration-300 hover:bg-zinc-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
                >
                  <div className="flex items-start justify-between mb-4">
                    <Icon className="w-8 h-8 text-amber-500" aria-hidden="true" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500">{agent.badge}</span>
                  </div>
                  <h3 className="font-display text-xl uppercase mb-2 group-hover:text-amber-500 transition-colors">
                    {t(agent.titleKey)}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed mb-4">{t(agent.descKey)}</p>
                  <div className="font-display text-2xl text-amber-500 mb-2">{agent.price}</div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-400 mb-6">
                    {agent.channels}
                  </p>
                  <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 group-hover:text-amber-500 transition-colors">
                    {t('marketplace_section.view_agent')} <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>

        {/* SEÇÃO DE SKILLS - PRODUTO SECUNDÁRIO */}
        <div className="mt-16 border-t border-zinc-900 pt-12">
          <h3 className="font-display text-xl uppercase text-amber-500 mb-6">SKILLS ADICIONAIS</h3>
          <p className="text-zinc-400 mb-8 max-w-2xl">Precisa de mais funcionalidades? Adicione skills especializados ao seu agente existente.</p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {SKILLS_CATALOG.map((skill) => {
              const Icon = skill.icon || ArrowRight;
              return (
                <Link
                  key={skill.slug}
                  to={skill.href}
                  className="group border border-zinc-800 hover:border-amber-500/30 bg-[#09090B] p-6 transition-all duration-300 hover:bg-zinc-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <ArrowRight className="w-4 h-4 text-amber-500" aria-hidden="true" />
                    <h3 className="font-display text-lg uppercase group-hover:text-amber-500 transition-colors">
                      {t(skill.titleKey)}
                    </h3>
                  </div>
                  <p className="text-zinc-400 text-sm leading-relaxed mb-3">{t(skill.descKey)}</p>
                  <div className="font-display text-lg text-amber-500 mb-2">{skill.price}</div>
                  <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-400">
                    ADICIONAR AO SEU AGENTE
                  </span>
                </Link>
              );
            })}
          </div>
          <div className="mt-6 text-center">
            <Link
              to="/marketplace/skills"
              className="inline-flex items-center gap-2 text-amber-500 hover:text-amber-400 font-mono text-xs uppercase tracking-wider transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
            >
              VER TODAS AS SKILLS <ArrowRight className="w-3 h-3" aria-hidden="true" />
            </Link>
          </div>
        </div>

        {/* CTAs */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/marketplace"
            className="group inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-400 text-black px-8 py-4 font-bold uppercase tracking-wider text-sm transition-all hover:shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
          >
            {t('marketplace_section.browse_all_agents')} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
          </Link>
          <Link
            to="/pricing"
            className="inline-flex items-center gap-3 border border-zinc-800 hover:border-zinc-500 text-white px-8 py-4 font-bold uppercase tracking-wider text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-black"
          >
            {t('marketplace_section.compare_with_max_os_cloud_plans')} <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}